(function () {
  function loadNoUiSlider(scriptEl, callback) {
    if (window.noUiSlider) {
      callback();
      return;
    }
    if (window.__loadingNoUiSlider) {
      window.__noUiSliderCallbacks = window.__noUiSliderCallbacks || [];
      window.__noUiSliderCallbacks.push(callback);
      return;
    }
    window.__loadingNoUiSlider = true;
    var src = scriptEl && scriptEl.dataset ? scriptEl.dataset.nouisliderSrc : null;
    if (!src) { return; }
    var tag = document.createElement('script');
    tag.src = src;
    tag.onload = function () {
      window.__loadingNoUiSlider = false;
      callback();
      (window.__noUiSliderCallbacks || []).forEach(function (cb) { cb(); });
      window.__noUiSliderCallbacks = [];
    };
    document.head.appendChild(tag);
  }

  function initSlider(container) {
    if (container.dataset.priceKgInitialized === '1') return;
    var wrapper = container.closest('.price-per-kg-filter');
    if (!wrapper) return;
    var checkboxWrap = wrapper.querySelector('.visually-hidden-checkboxes');
    if (!checkboxWrap) return;
    var checkboxes = Array.prototype.slice.call(checkboxWrap.querySelectorAll('input[type="checkbox"]'));
    if (!checkboxes.length) return;

    var formatRange = wrapper.dataset.formatRange || '€__LOW__ - __HIGH__ per kg';
    var formatRangeOpen = wrapper.dataset.formatRangeOpen || '€__LOW__+ per kg';

    if (checkboxes.length < 2) {
      // Slechts 1 prijsband aanwezig in deze collectie: een sleepbare slider heeft dan geen
      // functionele meerwaarde (er is toch maar 1 mogelijke stand). In plaats van de kale,
      // ongestylede browser-checkbox te tonen (zag er kapot/onaf uit), laten we hem als 1
      // nette pil-vormige toggle-knop zien die qua stijl bij de rest van de filter-UI past.
      checkboxWrap.classList.remove('visually-hidden-checkboxes');
      checkboxWrap.classList.add('price-per-kg-single-band');
      container.style.display = 'none';
      var summaryEl0 = wrapper.querySelector('[data-price-per-kg-summary]');
      if (summaryEl0) summaryEl0.style.display = 'none';
      container.dataset.priceKgInitialized = '1';
      return;
    }

    container.dataset.priceKgInitialized = '1';

    var max = checkboxes.length - 1;
    var starts = checkboxes.map(function (cb) { return cb.dataset.bandStart; });
    var ends = checkboxes.map(function (cb) { return cb.dataset.bandEnd; });
    var checkedIndexes = checkboxes
      .filter(function (cb) { return cb.checked; })
      .map(function (cb) { return parseInt(cb.dataset.bandIndex, 10); });

    var start = checkedIndexes.length
      ? [Math.min.apply(null, checkedIndexes), Math.max.apply(null, checkedIndexes)]
      : [0, max];

    var summaryEl = wrapper.querySelector('[data-price-per-kg-summary]');

    function formatText(lowIndex, highIndex) {
      var lowStart = starts[lowIndex];
      var highEnd = ends[highIndex];
      if (highEnd === '') {
        return formatRangeOpen.split('__LOW__').join(lowStart);
      }
      return formatRange.split('__LOW__').join(lowStart).split('__HIGH__').join(highEnd);
    }

    function updateLabels(values) {
      var lowIndex = Math.round(values[0]);
      var highIndex = Math.round(values[1]);
      if (summaryEl) summaryEl.textContent = formatText(lowIndex, highIndex);
    }

    noUiSlider.create(container, {
      start: start,
      connect: true,
      range: { min: 0, max: max },
      step: 1,
      behaviour: 'tap-drag',
      format: {
        to: function (value) { return Math.round(value); },
        from: function (value) { return Math.round(value); }
      }
    });

    updateLabels(start);

    container.noUiSlider.on('update', function (values) {
      updateLabels(values);
    });

    container.noUiSlider.on('set', function (values) {
      var lowIndex = Math.round(values[0]);
      var highIndex = Math.round(values[1]);
      var isFullRange = lowIndex === 0 && highIndex === max;
      var changed = false;

      checkboxes.forEach(function (cb) {
        var idx = parseInt(cb.dataset.bandIndex, 10);
        var shouldBeChecked = !isFullRange && idx >= lowIndex && idx <= highIndex;
        if (cb.checked !== shouldBeChecked) {
          cb.checked = shouldBeChecked;
          changed = true;
        }
      });

      if (changed && checkboxes[0]) {
        checkboxes[0].dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function initAll(scriptEl) {
    var sliders = document.querySelectorAll('[data-price-per-kg-slider]');
    if (!sliders.length) return;
    loadNoUiSlider(scriptEl, function () {
      sliders.forEach(initSlider);
    });
  }

  var currentScript = document.currentScript;
  var clearHandlerBound = false;

  function bindClearHandler() {
    if (clearHandlerBound) return;
    clearHandlerBound = true;
    // Capture phase so this runs before the theme's own bubble-phase
    // handlers (which stopPropagation() on '.no-click' anchors) can block it.
    document.addEventListener('click', function (e) {
      var clearLink = e.target.closest && e.target.closest('[data-clear-price-per-kg]');
      if (!clearLink) return;
      e.preventDefault();
      e.stopPropagation();
      var boxes = document.querySelectorAll('.price-per-kg-filter input[type="checkbox"]');
      var changed = false;
      boxes.forEach(function (cb) {
        if (cb.checked) {
          cb.checked = false;
          changed = true;
        }
      });
      if (changed && boxes[0]) {
        boxes[0].dispatchEvent(new Event('change', { bubbles: true }));
      }
    }, true);
  }

  function boot() {
    initAll(currentScript);
    bindClearHandler();

    var filterForm = document.getElementById('filter');
    var target = (filterForm && filterForm.closest('[id^="shopify-section-"]')) || document.body;
    var debounceTimer = null;
    var observer = new MutationObserver(function () {
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () { initAll(currentScript); }, 50);
    });
    observer.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
